import React, { useState } from "react";
import { Card, Form, Button, Row, Col } from "@themesberg/react-bootstrap";
import { attachAssetRowToTranches } from "../../service/api";
import { showNotification } from "../../service/showNotification";
import ConfirmationModal from "../../helper/ConfirmationModal";
import { tracker } from "../../service/mixpanel";

const AttachAssetsToTranches = ({
  tranche,
  loadTranches,
  onClose,
  onAssetsAttached,
}) => {
  const [assetId, setAssetId] = useState("");
  const [loading, setLoading] = useState(false);
  const notifyTrancheAssetsChanged = () => {
    if (!tranche?._id) return;
    if (typeof onAssetsAttached !== "function") return;
    onAssetsAttached(tranche._id);
  };

  // confirmation modal
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [modalName, setModalName] = useState("");

  const trancheName = tranche?.trancheName;

  const toggleConfirmationModal = (name = "") => {
    setIsConfirmationModal((prev) => !prev);
    setModalName(name);
  };

  const handleSubmit = async (event) => {
    tracker.tranches.attachAssetRowToTranches(assetId, tranche._id);
    event.preventDefault();
    const trimmedAssetId = assetId.trim();

    // Don't allow empty or whitespace-only values
    if (!trimmedAssetId) {
      showNotification("error", "Asset ID cannot be empty or whitespace.");
      return;
    }
    setLoading(true);

    try {
      const res = await attachAssetRowToTranches({
        trancheId: tranche._id,
        assetId: trimmedAssetId,
      });
      console.log("Asset attach response:", res);
      if (res.data.alreadyAttached) {
        toggleConfirmationModal("confirm_asset");
      } else {
        showNotification("success", `Asset attached to tranche successfully!`);
        setAssetId("");
        notifyTrancheAssetsChanged();
        onClose();
      }
    } catch (error) {
      console.error("Error attaching asset to tranche:", error);
      let message =
        error?.response?.data?.message ||
        "Failed to reattach asset. Please try again.";
      showNotification("error", message);
    } finally {
      setLoading(false);
      loadTranches();
    }
  };

  const handleConfirmAttach = async () => {
    tracker.tranches.attachAssetRowToTranches(assetId, tranche._id);
    setLoading(true);
    try {
      const res = await attachAssetRowToTranches({
        trancheId: tranche._id,
        assetId: assetId.trim(),
        forceAttach: true,
      });
      console.log("Asset force-attached successfully:", res);
      showNotification("success", `Asset attached to tranche successfully!`);

      setAssetId("");
      notifyTrancheAssetsChanged();
      loadTranches();
      onClose();
    } catch (error) {
      console.error("Error force-attaching asset:", error);
      let message =
        error?.response?.data?.message ||
        "Failed to reattach asset. Please try again.";
      showNotification("error", message);
    } finally {
      setLoading(false);
    }
  };

  const confirmationModalMap = {
    confirm_asset: {
      title: "Confirm Asset Reattachment",
      onConfirm: handleConfirmAttach,
    },
  };

  return (
    <>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4">Attach Asset to {trancheName}</h5>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group id="assetId">
                  <Form.Label>Asset ID</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Asset ID"
                    value={assetId}
                    onChange={(e) => setAssetId(e.target.value)}
                    disabled={loading}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-3">
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? "Attaching..." : "Attach Asset"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      <ConfirmationModal
        show={isConfirmationModal}
        onHide={() => toggleConfirmationModal()}
        onConfirm={confirmationModalMap[modalName]?.onConfirm}
        title={confirmationModalMap[modalName]?.title || "Something went wrong"}
      />
    </>
  );
};

export default AttachAssetsToTranches;
